//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: null
    },
    formData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    btnType: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      formInline: {
        user: '',
        region: '',
        date: null
      }
    };
  },
  methods: {
    searchForm: function searchForm() {
      this.$emit('searchForm', this.formData);
    },
    exportTable: function exportTable() {
      this.$emit('exportTable', this.formData);
    },
    addTable: function addTable() {
      this.$emit('addTable', this.formData);
    },
    resetForm: function resetForm() {
      this.$emit('resetForm', this.formData);
    },
    delForm: function delForm() {
      this.$emit('delForm');
    },
    editForm: function editForm() {
      this.$emit('editForm');
    },
    manualForm: function manualForm() {
      this.$emit('manualForm');
    },
    pause: function pause() {
      this.$emit('pause');
    },
    recovery: function recovery() {
      this.$emit('recovery');
    }
  }
};